<template>
  <div v-if="currentRoles.name === '素材管理'" class="page-index material-index">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['素材管理-新增']" class="btn-left" size="mini" @click="openModel()">添加素材</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select class="search-input2" v-model="type">
        <el-option v-for="item in libraryList" :key="item.value" :label="item.description" :value="item.value"></el-option>
      </el-select>
      <el-input  class="search-input" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入素材名称" />
    </div>

    <el-table
        ref="userTable"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="所属公司">
        <template slot-scope="scope">
          <div>{{scope.row.company.name}}</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="类型">
        <template slot-scope="scope">
          <div v-if="scope.row.type === 1">公司log</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="预览">
        <template slot-scope="scope">
          <img :src="scope.row.urlPath" height="70">
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.editer">
            <div v-if="currentRoles.roles['素材管理-禁用']" style="display:inline-block;margin-right:10px;">
              <el-tooltip v-if="scope.row.status === 0" content="禁用" placement="top">
                <el-button size="mini" @click.stop="handleSwitch(scope.row)" title="禁用">
                  <i class="icon el-icon-disable"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip v-if="scope.row.status === 1" content="启用" placement="top">
                <el-button size="mini" @click.stop="handleSwitch(scope.row)">
                  <i class="icon el-icon-enable"></i>
                </el-button>
              </el-tooltip>
            </div>
            <el-tooltip v-if="currentRoles.roles['素材管理-编辑']" content="编辑" placement="top">
              <el-button size="mini" @click.stop="openModel1(scope.row)">
                <i class="icon el-icon-edit"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="currentRoles.roles['素材管理-删除']" content="删除" placement="top">
              <el-button size="mini" @click.stop="handleDelete(scope.row)">
                <i class="icon el-icon-delete"></i>
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加素材"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="model1" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input placeholder="请输入名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select class="search-input2" v-model="form.type">
            <el-option v-for="item in libraryList" :key="item.value" :label="item.description" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="素材" prop="url" v-if="dialogVisible">
          <upload-image ref="file"></upload-image>
          <el-input v-show="false" v-model="form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改素材"
        :visible.sync="dialogVisible3"
        width="550px"
        :before-close="handleClose">
      <el-form ref="model2" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择公司" disabled>
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input placeholder="请输入名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select class="search-input2" v-model="form.type" disabled>
            <el-option v-for="item in libraryList" :key="item.value" :label="item.description" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="素材" prop="url" v-if="dialogVisible3">
          <upload-image ref="file1"></upload-image>
          <el-input v-show="false" v-model="form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiAdd, apiList, apiDelete, apiSwitchStatus, apiEdit } from '../../api/material'
  import { apiUpload } from '../../api/file'
  import { apiLibrary } from '../../api/master'
  import UploadImage from '../../components/upload-image/upload-image'

  export default {
    mixins: [tableMixin],
    name: 'material',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        list: [],
        libraryList: [],
        total: 0,
        query: {
          query: '',
          companyIds: []
        },
        type: 1,
        form: {},
        rules: {
          companyId: [
            { required: true, message: '请选择公司', trigger: 'change' }
          ],
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            { max: 50, message: '长度在 50 个字符之内', trigger: 'blur' }
          ],
          url: [
            { required: true, message: '请选择素材', trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      UploadImage
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this._getList()
      this.getLibrary()
    },
    activated() {},
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel() {
        this.dialogVisible = true
        this.form = {
          companyId: '',
          name: '',
          type: 1,
          url: ''
        }
        if (this.userInfo.companyList.length === 1) {
          this.form.companyId = this.userInfo.companyList[0].id
        }
        if (this.$refs['model1']) {
          this.$refs['model1'].resetFields()
        }
      },
      openModel1(row) {
        this.dialogVisible3 = true
        this.form = {
          id: row.id,
          url: '',
          name: row.name,
          companyId: row.companyId,
          type: row.type
        }
        if (this.$refs['model2']) {
          this.$refs['model2'].resetFields()
        }
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
          this.dialogVisible3 = false
          this.form = {}
          this.currentRow = {}
        }).catch(_ => {})
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 获取素材类型列表
      getLibrary() {
        apiLibrary().then(data => {
          this.libraryList = data.data
        })
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiList(this.query, this.type, pageIndex).then(data => {
          data.data.data.forEach(item => {
            let index = -1
            if (this.userInfo.companyIds) {
              index = this.userInfo.companyIds.split(',').indexOf(item.companyId + '')
            }
            if (index > -1) {
              item.editer = true
            } else {
              item.editer = false
            }
          })
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 添加
      handleAdd() {
        if (this.$refs.file.file.raw !== undefined) {
          this.form.url = this.$refs.file.file.raw
        }
        this.$refs['model1'].validate((valid) => {
          if (valid) {
            let param = new FormData()
            param.append('file', this.$refs.file.file.raw, this.$refs.file.file.name)
            apiUpload(param).then(imageUrl => {
              this.form.url = imageUrl.data
              apiAdd(this.form).then(() => {
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
                this._getList()
                this.dialogVisible = false
              })
            })
          }
        })
      },
      // 编辑
      handleEdit() {
        if (this.$refs.file1.file.raw !== undefined) {
          this.form.url = this.$refs.file1.file.raw
        }
        this.$refs['model2'].validate((valid) => {
          if (valid) {
            let param = new FormData()
            param.append('file', this.$refs.file1.file.raw, this.$refs.file1.file.name)
            apiUpload(param).then(imageUrl => {
              this.form.url = imageUrl.data
              apiAdd(this.form).then(() => {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
                this._getList()
                this.dialogVisible3 = false
              })
            })
          }
        })
      },
      // 禁用/启用
      handleSwitch(row) {
        this.$confirm(`是否${row.status === 0 ? '停用' : '启用'}素材：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiSwitchStatus(row.id).then(() => {
            this.$message({
              type: 'success',
              message: `${row.status === 0 ? '停用' : '启用'}成功`
            })
            this._getList()
          })
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除素材：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id, 2).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.material-index
    .btn-left
      background #A5CE1C
      color #fff
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
      .search-input2
        margin-right 10px
    .el-form-item__content
      width 200px
</style>
